<template lang="pug">
	div

		NothingFound(v-if="!scheduleSessions.length" text="Вы еще не добавили ни одного доклада" :buttonUrl="`/events-conferences/${eventID}#lectures`" button buttonText="Дополнить программу")

		.schedule-header.mb-3(v-else)
			b-button.schedule-header__btn.mb-2.mb-md-0(variant="success" :to="`/events-conferences/${eventID}#lectures`") Дополнить программу
			.d-flex
				b-button.schedule-header__btn.mr-2(variant="primary" @click="downloadSchedule" :disabled="isDownloading")
					b-spinner.mr-2(small label="Small Spinner" v-if="isDownloading")
					i.fa.fa-file-pdf-o.fa-md.mr-2(v-else)
					span Загрузить в PDF

				b-button.schedule-header__btn(variant="primary" @click="sendSchedule" :disabled="isSending")
					b-spinner.mr-2(small label="Small Spinner" v-if="isSending")
					i.fa.fa-envelope-o.fa-md.mr-2(v-else)
					span Отправить на email

		sessionsComponent(:sess="scheduleSessions" :eventID="eventID" :participantID="participantID")

</template>

<script>
	import { mapState } from 'vuex'
	import sessionsComponent from '../../components/sessions.vue'
	import forceFileDownload from '@/MIXINS/forceFileDownload'


	export default {
		name: 'ScheduleTab',
		components: {
			sessionsComponent,
		},
		mixins: [
			forceFileDownload,
		],
		data: () => ({
			isSending: false,
			isDownloading: false,
			msg: {
				netErr: 'Произошла ошибка! Проверьте интернет соединение или попробуйте повторить попытку позднее!'
			}
		}),
		computed: {
			...mapState(['myParticipant']),
			participantID(){ return this.myParticipant.data.id },
			eventID(){ return this.myParticipant.data.event.id },
			scheduleSessions(){ return this.myParticipant.data.session } ,
		},
		methods: {
			downloadSchedule(){
				this.isDownloading = true;
				this.$store.dispatch('downloadSchedule',{id:this.participantID})
					.then(resp=>{
						if ( !resp || !resp.ok ) throw resp.body;

						this.forceFileDownload(resp.data);
						this.isDownloading = false;
					})
					.catch(err=>{
						this.isDownloading = false;
						this.makeToast(null, err.statusText || this.msg.netErr, 'danger');
					})
			},
			sendSchedule(){
				this.isSending = true;
				this.$store.dispatch('sendSchedule',{id:this.participantID})
					.then(resp=>{
						if ( !resp || !resp.ok ) throw resp.body;

						this.isSending = false;
						this.makeToast(null, 'Программа успешно отправлено на Вашу электронную почту!', 'success');
					})
					.catch(err=>{
						console.error(err);
						this.isSending = false;
						this.makeToast(null, err.statusText || 'Произошла ошибка! Проверьте интернет соединение или попробуйте повторить попытку позднее!', 'danger');
					})
			},
			makeToast(append=false, msg='default text', variant='info', noHide=false) {
				this.$bvToast.toast([msg], {
					title: 'Центр уведомлений',
					toaster: 'b-toaster-bottom-right',
					autoHideDelay: 2000,
					appendToast: append,
					variant: variant,
					noAutoHide: noHide
				})
			},
		},
	}
</script>
